import React from 'react';
import { useIntl } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';
import SimilarRentalsCarousel from '@/components/common/SimilarRentalsCarousel';
import Button, { ButtonSize, ButtonVariants } from '@/components/switchback/Button/Button';
import { EListingSource } from '@/services/analytics/listings/types';

interface IRentalsList {
  rentals: [];
  inline: boolean;
  goToRentals: (event: React.MouseEvent<HTMLButtonElement>) => void;
  experimentEnabled: boolean;
}

export const RentalsList: React.FC<IRentalsList> = ({ goToRentals }) => {
  const intl = useIntl();
  const textButton = intl.formatMessage({
    defaultMessage: 'See all rentals',
    id: 'AI18Hm',
  });

  return (
    <>
      <MaxWidth collapseMobile className="px-0 mb-8" id="rentals">
        <SimilarRentalsCarousel eventSource={EListingSource.GRID_LAYOUT} />
      </MaxWidth>

      <div className="flex justify-center" id="rentals">
        <div className="w-64">
          <Button
            id="rentalButton"
            className="w-full"
            onClick={goToRentals}
            size={ButtonSize.normal}
            variant={ButtonVariants.primaryOutlined}>
            {textButton}
          </Button>
        </div>
      </div>
    </>
  );
};
